import store from '@/state/store';

export default async function onMessageMessageNew(dataJson) {
  const {chat_id} = dataJson.body;
  const {rooms} = store.state;

  dataJson.body.message.chat_id = chat_id;
  dataJson.body.meta_id = dataJson.meta.id;

  // add to open chat
  if (rooms.selectedRoomId === chat_id) {
    store.commit('room/ADD_MESSAGE', {...dataJson.body});
  }

  // add to list chat
  !rooms.rooms[chat_id] && await store.dispatch('rooms/one', {id: chat_id});
  store.commit('rooms/ADD_MESSAGE_LAST', {...dataJson.body.message, ...dataJson.body});
  if (rooms.selectedRoomId !== chat_id && dataJson.body.message.emitter === 0) {
    store.commit('rooms/UNREAD_MESSAGE', dataJson.body.message);
  }
  store.commit('rooms/SET_LIST_BASE', [chat_id]);

  //notifyOnMessageNew(dataJson.body);
}
